// Service for accessing legacy localStorage data
// This is used for migration purposes only.

const STORAGE_KEY_PLAN = 'onboarding_study_plan';
const STORAGE_KEY_DATA = 'onboarding_answers';

/**
 * Checks if there is any legacy data in localStorage.
 */
export const hasLocalState = (): boolean => {
    return !!localStorage.getItem(STORAGE_KEY_PLAN);
};

/**
 * Reads the full state from localStorage.
 * Returns null if no plan exists (even if answers exist, we need a plan to be useful).
 */
export const readLocalState = (): { onboardingData: any; studyPlan: any } | null => {
    try {
        const planStr = localStorage.getItem(STORAGE_KEY_PLAN);
        const dataStr = localStorage.getItem(STORAGE_KEY_DATA);

        if (!planStr) return null;

        return {
            onboardingData: dataStr ? JSON.parse(dataStr) : null,
            studyPlan: JSON.parse(planStr)
        };
    } catch (e) {
        console.error("Failed to read local legacy state", e);
        return null;
    }
};

/**
 * Clears the legacy data from localStorage.
 * Should be called after successful migration.
 */
export const clearLocalState = (): void => {
    localStorage.removeItem(STORAGE_KEY_PLAN);
    localStorage.removeItem(STORAGE_KEY_DATA);

    // Also clear other legacy keys if we want to be thorough, 
    // but the main ones are these.
    // We might want to clear 'pendingMission' etc? 
    // Let's stick to the core data for now.
};
